export default "__VITE_ASSET__Df77mXrB__"